import R from 'ramda';

import { OpeningTimes } from 'apis/restaurant-api/merchant-admin/venue/types';
import fromWeeklyScheduleToTimePairsByWeekday, {
  TimePair,
} from 'common/components/weekly-schedules/fromWeeklyScheduleToTimePairsByWeekday';
import { EMPTY_WEEKLY_SCHEDULE } from 'common/components/weekly-schedules/values';
import time from 'common/utils/time';
import { WEEKDAYS } from 'common/utils/time/values';

export const isOpeningTimesEmpty = (openingTimes: OpeningTimes) => {
  return R.equals(openingTimes, {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
  });
};

type TimesProps = {
  openingTimes: OpeningTimes | null;
  deliveryProviderDeliveryTimes: OpeningTimes | null;
  deliveryTimes: OpeningTimes | null;
  cappedDeliveryTimes: OpeningTimes | null;
  isSelfDelivery?: boolean;
};

type DeliveryTimesBreakdownByWeekday = {
  weekday: Weekday;
  openingTimesText: string[];
  hideDeliveryProviderDeliveryTimes: boolean;
  deliveryProviderDeliveryTimesText: string[] | null;
  defaultDeliveryTimes: 'wolt-delivery-times' | 'opening-times';
  deliveryTimesText: string[] | null;
  cappedDeliveryTimesText: string[];
};

const timePairToText = (timePair: TimePair) =>
  `${time.renderMinutesFromMidnight(timePair.start, false)}-${time.renderMinutesFromMidnight(timePair.end, true)}`;

export const transformDeliveryTimesToBreakdownByWeekday = ({
  cappedDeliveryTimes,
  deliveryProviderDeliveryTimes,
  deliveryTimes,
  openingTimes,
  isSelfDelivery,
}: TimesProps): DeliveryTimesBreakdownByWeekday[] => {
  const transformedOpeningTimes = fromWeeklyScheduleToTimePairsByWeekday(openingTimes || EMPTY_WEEKLY_SCHEDULE);
  const transformedDeliveryProviderDeliveryTimes = fromWeeklyScheduleToTimePairsByWeekday(
    deliveryProviderDeliveryTimes || EMPTY_WEEKLY_SCHEDULE,
  );
  const transformedDeliveryTimes = fromWeeklyScheduleToTimePairsByWeekday(deliveryTimes || EMPTY_WEEKLY_SCHEDULE);
  const transformedCappedDeliveryTimes = fromWeeklyScheduleToTimePairsByWeekday(
    cappedDeliveryTimes || EMPTY_WEEKLY_SCHEDULE,
  );

  return WEEKDAYS.map(weekday => ({
    weekday,
    openingTimesText: transformedOpeningTimes[weekday].map(timePairToText),
    hideDeliveryProviderDeliveryTimes: !!isSelfDelivery,
    deliveryProviderDeliveryTimesText:
      deliveryProviderDeliveryTimes && !isSelfDelivery
        ? transformedDeliveryProviderDeliveryTimes[weekday].map(timePairToText)
        : null,
    defaultDeliveryTimes: isSelfDelivery ? 'opening-times' : 'wolt-delivery-times',
    deliveryTimesText: deliveryTimes ? transformedDeliveryTimes[weekday].map(timePairToText) : null,
    cappedDeliveryTimesText: transformedCappedDeliveryTimes[weekday].map(timePairToText),
  }));
};
